import { cn } from "~/core/generic/shadcn-utils";

export default function CalendarClockIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={cn(className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
    >
      <path
        fill="currentColor"
        d="M0 128C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 6.6c-11.2 3.2-21.9 7.4-32 12.6l0-19.2L32 192l0 256c0 17.7 14.3 32 32 32l296.3 0c9.8 11.8 21 22.3 33.5 31.3c-3.2 .5-6.4 .7-9.8 .7L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32zm32 0l0 32 384 0 0-32c0-17.7-14.3-32-32-32L64 96c-17.7 0-32 14.3-32 32zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm96-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64z"
      />
    </svg>
  );
}
